import { me } from '../api/user'
import * as types from './types';

const request = () => {
  return {
    type: types.REQUEST,
    payload: true,
  }
}

const success = payload => {
  return {
    type: types.SUCCESS,
    payload
  }
}

const error = error => {
  return {
    type: types.ERROR,
    payload: error,
  }
}

const meAction = () => {  
  return dispatch => {
    dispatch(request());    
    me()
      .then(({ data }) => {
        dispatch(success(data));
    }).catch(({ response }) => {
      dispatch(error(response.data.error));
      
    });
  }
};

export {
  request,
  success,
  error,
  meAction
};



// WEBPACK FOOTER //
// ./src/store/user/action.js